import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { TokenService } from "./token.service";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})

export class PackService {
    apiUrl = environment.API_URL + 'internal/';

    constructor(
        private httpClient: HttpClient,
        private tokenService: TokenService
    ) { }

    private getCustomerHeader() {
        return new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + this.tokenService.getComponentCodeToken(),
            'Accept-Language': 'pt-BR'
        });
    }

    private getV2Header() {
        return new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + this.tokenService.getTokenV2(),//token V2
            'Accept-Language': 'pt-BR'
        });
    }

    public getCapaPack(PackNumber: number, PackBarCode: string): Observable<any> {
        let params = new HttpParams();
        if (PackNumber) {
            params = params.set('PackNumber', PackNumber.toString());
        } else {
            params = params.set('PackBarCode', PackBarCode.toString());
        }
        return this.httpClient.get<any>(this.apiUrl + 'product/v2/packs', {
            params: params,
            headers: this.getCustomerHeader()
        });
    }

    public postItemPack(packNumber: number, productSku: string, quantity: number): Observable<any> {
        let data = {
            "packNumber": packNumber,
            "productSku": productSku,
            "quantity": quantity
        }
        return this.httpClient.post<any>(this.apiUrl + 'product/v2/items-pack', data, { headers: this.getCustomerHeader() });
    }

    public deleteItemPack(packNumber: number, itemBarCode: string): Observable<any> {
        let data = {
            "packNumber": packNumber,
            "productSku": itemBarCode
        }
        return this.httpClient.request('DELETE', this.apiUrl + 'product/v2/items-pack', {
            body: data,
            headers: this.getCustomerHeader()
        });
    }

    public postCustomerToken2(componentCode: string): Observable<any> {
        let data = {
            'componentCode': componentCode,
        }
        return this.httpClient.post<any>(this.apiUrl + 'authorization/v2/customer-component-token', data, { headers: this.getV2Header() });
    }

    public getCapaPackGroup(PackNumber: number, PackBarCode: string): Observable<any> {
        let params = new HttpParams();
        if (PackNumber) {
            params = params.set('PackNumber', PackNumber.toString());
        } else {
            params = params.set('PackBarCode', PackBarCode.toString());
        }
        return this.httpClient.get<any>(this.apiUrl + 'product/v2/packs-group', {
            params: params,
            headers: this.getCustomerHeader()
        });
    }
}